export const TEXT_TYPE = 'TextType';

export const TEL_TYPE = 'TelType';

export const EMAIL_TYPE = 'EmailType';

export const PASSWORD_TYPE = 'PasswordType';

export const HIDDEN_TYPE = 'HiddenType';

export const CHECKBOX_TYPE = 'CheckboxType';

export const CHOICE_TYPE = 'ChoiceType';

export const ENTITY_TYPE = 'EntityType';
